import React from "react";
import { MessageCircle } from "lucide-react";

export const WHATSAPP_NUMBER = "+41 79 925 53 01";
export const WHATSAPP_LOCAL = "079 925 53 01";
export const WHATSAPP_HREF = "https://wa.me/41799255301";
export const PHONE_HREF = "tel:+41799255301";

const WhatsAppFab = () => (
  <a
    href={WHATSAPP_HREF}
    target="_blank"
    rel="noreferrer"
    aria-label="WhatsApp SAFEMAT"
    data-testid="whatsapp-fab"
    className="fixed bottom-5 right-5 z-40 flex items-center gap-2 bg-[#25D366] text-white px-4 py-3 rounded-full shadow-lg shadow-emerald-900/20 hover:shadow-emerald-900/40 hover:scale-105 transition-all"
  >
    <MessageCircle size={20} strokeWidth={2.2} />
    <span className="hidden sm:inline text-sm font-semibold">WhatsApp</span>
  </a>
);

export default WhatsAppFab;
